import React, { useState } from 'react';
import moment from 'moment';

/**
 * Component for creating a new stock take
 * @param {Object} props - Component props
 * @param {Boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Function} props.onSubmit - Function to submit the form
 */
const NewStocktakeModal = ({ isOpen, onClose, onSubmit }) => {
  const [name, setName] = useState(moment().format('YYYY-MM-DD'));
  const [notes, setNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    onSubmit({ name, notes })
      .then(() => {
        // Reset form and close modal on success
        setName(moment().format('YYYY-MM-DD'));
        setNotes('');
        onClose();
      })
      .catch(error => {
        console.error('Error creating stock take:', error);
        alert('Failed to create stock take. Please try again.');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="new-stocktake-modal">
      <div className="new-stocktake-modal-content">
        <div className="new-stocktake-modal-header">
          <h2 className="new-stocktake-modal-title">New Stock Take</h2>
          <button 
            className="new-stocktake-modal-close" 
            onClick={onClose}
            disabled={isSubmitting}
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="new-stocktake-form-group">
            <label className="new-stocktake-form-label" htmlFor="stocktake-name">
              Name
            </label>
            <input
              id="stocktake-name"
              type="text"
              className="new-stocktake-form-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={isSubmitting}
            />
          </div>
          
          <div className="new-stocktake-form-group">
            <label className="new-stocktake-form-label" htmlFor="stocktake-notes">
              Notes (Optional)
            </label>
            <textarea
              id="stocktake-notes"
              className="new-stocktake-form-textarea"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              disabled={isSubmitting}
              placeholder="Add any notes about this stock take..."
            />
          </div>
          
          <div className="new-stocktake-form-buttons">
            <button
              type="button"
              className="new-stocktake-form-button new-stocktake-form-button-cancel"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="new-stocktake-form-button new-stocktake-form-button-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Creating...' : 'Create Stock Take'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewStocktakeModal;